/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLogoutIcon16Solid = forwardRef('ArrowUiAuthLogoutIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 3.5A2.5 2.5 0 0 0 6.5 1h-4A2.5 2.5 0 0 0 0 3.5v9A2.5 2.5 0 0 0 2.5 15h4A2.5 2.5 0 0 0 9 12.5V9h3.82l-1.792 1.793a1 1 0 0 0 1.414 1.414l3.003-3.003a1.703 1.703 0 0 0 0-2.408l-3.003-3.003a1 1 0 1 0-1.414 1.414L12.82 7H9V3.5ZM9 7H4.5a1 1 0 1 0 0 2H9V7Z" })));
});
